import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSiteSettings } from "@/context/LanguageContext";
import { applyTheme } from "@/lib/theme";

const setIcon = (sel, href) => { const el = document.head.querySelector(sel); if (el && href) el.href = href; };

/** Eigenes Favicon aus Admin → Logo & Wasserzeichen (…/favicon-<ts>.png = 192 px; Varianten -180.png und .ico liegen daneben). */
const applyFavicon = (url) => {
  if (!url || !/\.png$/i.test(url)) return;
  const base = url.replace(/\.png$/i, "");
  setIcon('link[rel="icon"][sizes="any"]', `${base}.ico`);
  setIcon('link[rel="icon"][type="image/png"]', url);
  setIcon('link[rel="apple-touch-icon"]', `${base}-180.png`);
};

/** Überträgt das im Admin gespeicherte Design (Farben, Schrift, Kopfzeile, Favicon) – nur außerhalb des Admin-Bereichs. */
export const ThemeApplier = () => {
  const { pathname } = useLocation();
  const site = useSiteSettings();
  useEffect(() => { applyTheme(site, !pathname.startsWith("/admin")); }, [site, pathname]);
  useEffect(() => { if (!pathname.startsWith("/admin")) applyFavicon(site.favicon_url); }, [site.favicon_url, pathname]);
  return null;
};
